import { translate } from "@js/common/helpers";
import * as React from "react";
import { useEffect, useState } from "react";
var MAX_CHARACTERS = 400;
var Textarea = function (_a) {
    var afterCommentChange = _a.afterCommentChange, rating = _a.rating;
    var _b = useState((rating === null || rating === void 0 ? void 0 : rating.comment) || ''), comment = _b[0], setComment = _b[1];
    var _c = useState(MAX_CHARACTERS), charactersLeft = _c[0], setCharactersLeft = _c[1];
    var handleTextareaChange = function (event) {
        var newComment = event.target.value;
        setComment(newComment);
        if (typeof afterCommentChange === 'function') {
            afterCommentChange(newComment);
        }
    };
    useEffect(function () {
        setCharactersLeft(MAX_CHARACTERS - (comment === null || comment === void 0 ? void 0 : comment.length));
    }, [comment]);
    return (React.createElement("div", { className: "comment-field " + (charactersLeft <= 0 ? 'max-exceeded' : '') },
        React.createElement("textarea", { defaultValue: comment, rows: 5, maxLength: MAX_CHARACTERS, placeholder: translate('collection_rating.form.comment.placeholder'), onChange: handleTextareaChange }),
        React.createElement("p", { className: "remaining-characters" },
            React.createElement("b", null, charactersLeft),
            " characters left")));
};
export { Textarea };
